import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({

    titleContainer: {
        position: 'absolute',
        bottom: 30,
        paddingLeft: 40
    },
    reportTitle: {
        fontSize: 7.5,
        textAlign: 'left',
    },

    // Estilos para debitNote
    debitNoteTitleContainer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        paddingLeft: 40,
        fontSize: 7,
        paddingRight: 40,
    },
    debitNoteTitle: {
        fontSize: 7,
        textAlign: 'center',
    },
    debitNoteLine: {
        borderTopWidth: 1,
        borderTopColor: '#000',
        marginBottom: 5,
        fontSize: 7,
    },

    creditNoteContainer: {
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 7,
        textAlign: 'justify',
        lineHeight: 1.3,
    },
    creditNoteTitle: {
        fontSize: 7,
        fontWeight:'300',
        marginBottom: 5,
    },
    creditNoteSection: {
        marginBottom: 3,
    },
    creditNoteSectionTitle: {
        fontSize: 7,
        fontWeight:'300',
        marginBottom: 2,
    },
    creditNoteText: {
        fontSize: 7,
        textAlign: 'justify',
        lineHeight: 1.3,
    },
    
    pageNumber: {
        position: 'absolute',
        fontSize: 8,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
});


const ThankYouMsg = ({ header, _user, view }) => {
    if (view === 'creditNote' && header.U_BPP_MDTD === 'DV' ) {
        return (
            <View style={styles.creditNoteContainer}>
                <Text style={styles.creditNoteTitle}>Condiciones Cesión de Uso de Cilindros de Llama Gas: En cumplimiento del Art.51° Decreto Supremo N° 01-94 EM</Text>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Primera: ANTECEDENTES.-</Text>
                    <Text style={styles.creditNoteText}>
                        LLAMA GAS S.A es una Empresa privada dedicada al envasado, comercialización y distribución de GAS Licuado de Petróleo (G.L.P.) a nivel nacional,
                        debidamente autorizada por la Dirección General de Hidrocarburos del Ministerio de Energía y Minas, y que tiene cilindros de su propiedad de 3,5,
                        10,15 y 45 kilos que los pone  a disposición de sus clientes consumidores.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Segunda: DE LA CESION DE USO DE CILINDROS.-</Text>
                    <Text style={styles.creditNoteText}>
                        Para posibilitar el suministro de G.L.P. que se pacta con el cliente, LLAMA GAS S.A. entrega al Cliente, en CESIÓN DE USO, los cilindros en kilos rotulados
                        con su marca, de la capacidad que se indica en el presente documento, y para tal efecto, en cumplimiento de los establecidos en el Art. 51 del D.S. N° 001-94-EM,
                        el Cliente deja en calidad de garantía, el equivalente al valor económico de los cilindros que se recibe en cesión de uso. Esta garantía no genera intereses.
                        En tal sentido, el cliente reconoce y declara que los CILINDROS son de propiedad exclusiva de LLAMA GAS S.A. y se obliga a devolverlos de conformidad con las
                        disposiciones establecidas en el presente documento y la legislación aplicable. LLAMA GAS S.A. podrá cobrar al cliente un importe adicional por concepto de
                        gastos administrativos relacionados con la gestión, emisión, seguimiento y control documental del proceso de cesión de uso. Dicho importe no forma parte de
                        la garantía y no es materia de devolución.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Tercera: ENTREGA DE LOS CILINDROS.-</Text>
                    <Text style={styles.creditNoteText}>
                        El cliente recibirá los cilindros en cualquiera de los Locales de Venta de LLAMA GAS S.A. o a través de su red de reparto. En ambos casos, se considerará
                        recibido el cilindro en buen estado operativo, salvo constancia en contra al momento de la entrega.
                    </Text>
                    <Text style={[styles.creditNoteText]}>
                        Cuarta: DEVOLUCION DE LA GARANTÍA POR CESIÓN EN USO.-</Text>
                    <Text style={[styles.creditNoteText]}>
                        El cliente podra pedir el dinero entregado en el depósito de LLAMA GAS S.A cuando devuelva los cilindros que recibió en cesión de uso y con la presentación
                        del original del presente recibo.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Quinta: EJECUCIÓN DE GARANTÍA.-</Text>
                    <Text style={styles.creditNoteText}>
                        LLAMA GAS S.A podrá ejecutar la garantía en un plazo de 6 meses a su fecha de emisión, en caso el cliente no devuelva los cilindros otorgados en cesión.
                        La garantía se podrá ejecutar de forma automática pasado dicho plazo sin necesidad de comunicación previa al cliente, de conformidad a lo dispuesto en el
                        artículo 1430° del Código Civil.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Sexta: AUTORIZACIÓN EXPRESA.-</Text>
                    <Text style={styles.creditNoteText}>
                        El cliente al suscribir el presente documento deja constancia de su autorización expresa, libre e incondicional a fin de que LLAMA GAS S.A. ejecute la garantía,
                        sin comunicación previa cuando se supere el plazo indicado en la Cláusula Quinta.
                    </Text>
                    
                </View>
                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Septima: RECOJO.-</Text>
                    <Text style={[styles.creditNoteText]}>
                        Cuando el cliente decide devolver el cilindro existirá un cobro por el servicio de recojo que será informado previamente. En caso el cliente opte por devolver
                        el cilindro en algún establecimiento de LLAMA GAS S.A. no se generará dicho cobro.
                    </Text>
                    
                </View>
            </View>
        );
    }

    if (view === 'invoice' && header.U_BPP_MDTD === 'CU') {
        return (
            <View style={styles.creditNoteContainer}>
                <Text style={styles.creditNoteTitle}>Condiciones Cesión de Uso de Cilindros de Llama Gas.: En cumplimiento del Art.51° Decreto Supremo N° 01-94 EM</Text>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Primera: ANTECEDENTES.-</Text>
                    <Text style={styles.creditNoteText}>
                        LLAMA GAS S.A. es una Empresa privada dedicada al envasado, comercialización y distribución de GAS Licuado de Petróleo (G.L.P.) a nivel nacional,
                        debidamente autorizada por la Dirección General de Hidrocarburos del Ministerio de Energía y Minas, y que tiene cilindros de su propiedad de 3,5,
                        10,15 y 45 Kilos que los pone  a disposición de sus clientes consumidores.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Segunda: DE LA CESION DE USO DE CILINDROS.-</Text>
                    <Text style={styles.creditNoteText}>
                        Para posibilitar el suministro de G.L.P. que se pacta con el cliente, LLAMA GAS S.A. entrega al Cliente, en CESIÓN DE USO, los cilindros en kilos rotulados
                        con su marca, de la capacidad que se indica en el presente documento, y para tal efecto, en cumplimiento de los establecidos en el Art. 51 del D.S. N° 001-94-EM,
                        el Cliente deja en calidad de garantía, el equivalente al valor económico de los cilindros que se recibe en cesión de uso. Esta garantía no genera intereses.
                        En tal sentido, el cliente reconoce y declara que los CILINDROS son de propiedad exclusiva de LLAMA GAS S.A. y se obliga a devolverlos de conformidad con las
                        disposiciones establecidas en el presente documento y la legislación aplicable. LLAMA GAS S.A. podrá cobrar al cliente un importe adicional por concepto de
                        gastos administrativos relacionados con la gestión, emisión, seguimiento y control documental del proceso de cesión de uso. Dicho importe no forma parte de
                        la garantía y no es materia de devolución.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Tercera: ENTREGA DE LOS CILINDROS.-</Text>
                    <Text style={styles.creditNoteText}>
                        El cliente recibirá los cilindros en cualquiera de los Locales de Venta de LLAMA GAS S.A. o a través de su red de reparto. En ambos casos, se considerará
                        recibido el cilindro en buen estado operativo, salvo constancia en contra al momento de la entrega.
                    </Text>
                    <Text style={[styles.creditNoteText]}>
                        Cuarta: DEVOLUCION DE LA GARANTÍA POR CESIÓN EN USO.-</Text>
                    <Text style={[styles.creditNoteText]}>
                        El cliente podra pedir el dinero entregado en el depósito de LLAMA GAS S.A cuando devuelva los cilindros que recibió en cesión de uso y con la presentación
                        del original del presente recibo.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Quinta: EJECUCIÓN DE GARANTÍA.-</Text>
                    <Text style={styles.creditNoteText}>
                        LLAMA GAS S.A podrá ejecutar la garantía en un plazo de 6 meses a su fecha de emisión, en caso el cliente no devuelva los cilindros otorgados en cesión.
                        La garantía se podrá ejecutar de forma automática pasado dicho plazo sin necesidad de comunicación previa al cliente, de conformidad a lo dispuesto en el
                        artículo 1430° del Código Civil.
                    </Text>
                </View>

                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Sexta: AUTORIZACIÓN EXPRESA.-</Text>
                    <Text style={styles.creditNoteText}>
                        El cliente al suscribir el presente documento deja constancia de su autorización expresa, libre e incondicional a fin de que LLAMA GAS S.A. ejecute la garantía,
                        sin comunicación previa cuando se supere el plazo indicado en la condición Quinta.
                        El cliente proporcionará sus datos para el envió electrónico del documento que acredita la cesión de uso (correo o celular); el envió a través de estos medios electrónicos
                        da por aceptados los términos y condiciones estipulados en el certificado.
                    </Text>
                </View>
                <View style={styles.creditNoteSection}>
                    <Text style={styles.creditNoteSectionTitle}>Septima: Recojo.-</Text>
                    <Text style={styles.creditNoteText}>
                        Cuando el cliente decida devolver el cilindro existirá un cobro por el servicio de recojo que séra informado previamente. En caso el cliente opte por devolver el cilindro 
                        en algún establecimiento de LLAMA GAS S.A. no se generará dicho cobro.
                    </Text>
                </View>
            </View>
        );
    }

    if (view === 'orderSales' && header.U_RS_TIPOV === 'ENVASA') {
         return (
            <>
            </>
         )
    }

    if (view === 'debitNote') {
        return (
            <>
                <View style={styles.debitNoteTitleContainer}>
                    <View style={styles.debitNoteLine}></View>
                    <Text style={styles.debitNoteTitle}> Autorizado para ser Emisor electrónico mediante la RS N° 300-2014</Text>
                    <Text style={styles.debitNoteTitle}>Código Hash: FVCTvftAw1NpkvS+qg/VHaYP6W4= | Cód. Establecimiento: 0021</Text>
                    <Text style={styles.debitNoteTitle}>Para consultar el comprobante ingresar a : https://portal.efacturacion.pe/appefacturacion </Text>
                </View>
            </>
        )
    }

    return (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>Elaborado por: {header.U_NAME ? header.U_NAME : ''}</Text>
        <Text style={styles.reportTitle}>Autorizado por: {header.Empleado}</Text>
        <Text style={styles.reportTitle}>{header.Comments ? "Comentarios: " + header.Comments : ''}</Text>
        {header.ObjType !== "1250000001" &&
            <Text style={styles.reportTitle}>NOTA: Favor respetar estrictamente los ítems y las cantidades solicitadas en el documento; cualquier modificación NO autorizada, ocasionará la devolución inmediata del artículo alterado.</Text>
        }
    </View>
);
};

export default ThankYouMsg